import { Button } from 'primereact/button'
import React, { useEffect } from 'react'
import { FaExclamationCircle } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'

const ErrorScreen: React.FC = () => {
  const navigate = useNavigate()

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/discover')
    }, 15000)

    return () => clearTimeout(timer)
}, [])

  const Error = () => {
    return (
      <div className="">
        <div className="text-center mb-3">{<FaExclamationCircle size={180} color="lightpink" />}</div>
        <p className="text-center fs-3 fw-bolder">Error has occured</p>
        <p className="text-center fs-4">
          <br />
          Please contact our customer support.
        </p>
      </div>
    )
  }

  return (
    <div>
      <Error />
      <div className="text-center my-4">
        <p className="text-center">you will be redirected to discover if not press the link:</p>
        <Button
          link
          label="Return to Discover"
          onClick={() => {
            navigate('/discover')
          }}
        ></Button>
      </div>
    </div>
  )
}

export default ErrorScreen
